export default {
  setError: (state, err) => {
    state.error = err;
  },

  clearError: state => {
    state.error = '';
  },
};
